export default __webpack_public_path__ + "static/media/Sesuatu Di Jogja - Adhitia Sofyan (official audio).b93b5c9d.mp3";